// extracted by mini-css-extract-plugin
export default {"header_container":"Header_header_container__aOGZE","list":"Header_list__R4BIU","item":"Header_item__WkkSW","logoPet":"Header_logoPet__i31eo"};